<video #videoEl autoplay loop playsinline>
  <source [src]="videoUrl" type='video/mp4'>
</video>
